import type { DeepPartial } from '@luna/utils-ts';

import type { AddressBook } from './AddressBook';

export const HU: DeepPartial<AddressBook> = {
    trustedContactsAvailable: true,
    contactDetails: {
        fetchAccountName: true,
        useDefaultCountry: true,
        fillingIbanResetsCountry: true,
        prefillCorrespondingIban: true,
    },
    abcSelectorButtons: [
        {
            icon: 'security-good',
            i18Key: 'addressbook:filter.trustedContacts',
            matches: 'TRUSTED_CONTACTS',
            alwaysEnabled: true,
        },
        {
            icon: 'star',
            i18Key: 'addressbook:filter.topContacts',
            matches: 'TOP_CONTACTS',
            alwaysEnabled: true,
        },
        {
            key: '123',
            matches: 'OTHER',
        },
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
    ],
    cacheDuration: {
        contact: 10000,
        template: 10000,
        templates: 10000,
        search: 5000,
    },
};
